import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { TemplateId } from 'data/templates/api';
import { ProjectTemplateSpace } from '../types';
import { useActiveTemplateId } from './use-active-project-template';

const getProjectTemplateSpace = () =>
  createSelector(
    (state: RootState) => state.templates.project,
    (_, templateId: TemplateId) => templateId,
    (project, templateId): { [key: string]: ProjectTemplateSpace } =>
      project.data[templateId]?.spaceList ?? {},
  );

export const useProjectTemplateSpaces = (): {
  [key: string]: ProjectTemplateSpace;
} => {
  const templateId = useActiveTemplateId();
  const templateObject = useMemo(getProjectTemplateSpace, []);

  return useSelector((state: RootState) => templateObject(state, templateId));
};
